<template>
  <div class="modal-wrapper">
    <div class="modal__btn" @click="onClickBtn">
      <slot name="button"></slot>
    </div>
    <div
      v-if="show"
      @click="onClickBg"
      :class="'modal' + (show ? ' modal--show' : '') + (closing ? ' modal--closing' : '')"
    >
      <div :class="modalBgClasses">
        <div :class="modalPanelClasses">
          <m4-button variant="default-text" class="close" @click="onClickCloseModal" tag="a">
            <m4-icon icon="close"></m4-icon>
          </m4-button>
          <m4-panel v-if="hasPanel">
            <template v-if="hasSlotHeader" v-slot:header>
              <slot name="header"></slot>
            </template>
            <template v-slot:default>
              <slot name="body"></slot>
            </template>
            <template v-if="hasSlotFooter" v-slot:footer>
              <slot name="footer"></slot>
            </template>
          </m4-panel>
          <template v-else>
            <slot></slot>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Modal",
  data() {
    return {
      show: this.initShow,
      closing: false
    };
  },
  props: {
    verticalCenter: Boolean,
    size: String,
    initShow: {
      type: Boolean,
      default() {
        return false;
      }
    },
    initShowWithDelay: {
      type: Number,
      default() {
        return 0;
      }
    },
    allowCloseByClickingOnBg: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  emits: ["closeModal", "openModal"],
  mounted() {
    if (this.initShowWithDelay > 0) {
      setTimeout(() => {
        this.show = true;
      }, this.initShowWithDelay);
    }
  },
  computed: {
    modalBgClasses() {
      let classes = ["modal__modal-bg"];
      if (this.verticalCenter) {
        classes.push("modal__modal-bg--vertical-center");
      }
      return classes;
    },
    modalPanelClasses() {
      let classes = ["modal__modal-bg__panel"];
      if (this.size) {
        classes.push("modal__modal-bg__panel--" + this.size);
      }
      return classes;
    },
    hasPanel() {
      return typeof this.$slots.header === "function" || typeof this.$slots.footer === "function";
    },
    hasSlotHeader() {
      return typeof this.$slots.header === "function";
    },
    hasSlotFooter() {
      return typeof this.$slots.footer === "function";
    }
  },
  methods: {
    onClickBtn() {
      this.show = true;
      this.$emit("openModal");
    },
    onClickCloseModal() {
      let self = this;
      self.closing = true;

      setTimeout(() => {
        self.show = false;
        self.closing = false;
      }, 250);

      this.$emit("closeModal");
    },
    onClickBg(e) {
      if (e.target.classList.contains("modal__modal-bg__panel") || e.target.classList.contains("modal__modal-bg")) {
        if (this.allowCloseByClickingOnBg) {
          this.onClickCloseModal();
        }
      }
    }
  }
};
</script>
